/* Hydro Flavor Wall — full-page searchable, family-filtered grid of all flavors.
   Each card links to the PDP with that flavor's variant preselected. */
(function () {
  'use strict';
  var norm = function (s) { return (s || '').toUpperCase().replace(/\(.*?\)/g, '').replace(/[^A-Z0-9]/g, ''); };

  function initWall(root) {
    if (root.dataset.wallReady) return;
    root.dataset.wallReady = '1';
    var grid = root.querySelector('[data-wall-grid]');
    var chipsWrap = root.querySelector('[data-wall-chips]');
    var search = root.querySelector('[data-wall-search]');
    var countEl = root.querySelector('[data-wall-count]');
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-wall-variants]').textContent); } catch (e) { return; }
    var data = { families: [], flavors: {} };
    var activeFamily = 'All';
    var query = '';
    function meta(t) { return data.flavors[norm(t)] || {}; }

    function card(v) {
      var m = meta(v.title);
      var sub = m.descriptor || m.family || '';
      var tag = m.bestseller ? '<span class="hydro-wall__tag">Bestseller</span>' : (m.is_new ? '<span class="hydro-wall__tag hydro-wall__tag--new">New</span>' : '');
      return '<a class="hydro-wall__card' + (v.available ? '' : ' is-sold') + '" href="' + v.url + '">' +
        '<span class="hydro-wall__dot" style="background:' + (m.accent || '#E8F8EE') + '">' + (m.emoji || '🍃') + '</span>' +
        '<span class="hydro-wall__txt"><span class="hydro-wall__name">' + (m.name || v.title) + '</span>' +
        '<span class="hydro-wall__sub">' + sub + '</span></span>' + tag +
        (v.available ? '' : '<span class="hydro-wall__sold">Sold out</span>') + '</a>';
    }
    function render() {
      var q = norm(query);
      var list = variants.filter(function (v) {
        var m = meta(v.title);
        if (activeFamily !== 'All' && m.family !== activeFamily) return false;
        if (q && norm(m.name || v.title).indexOf(q) === -1) return false;
        return true;
      });
      grid.innerHTML = list.map(card).join('') || '<p class="hydro-wall__empty">No flavors match. Try another search.</p>';
      if (countEl) countEl.textContent = list.length + ' of ' + variants.length + ' flavors';
    }
    function chips() {
      var fams = ['All'].concat(data.families || []);
      chipsWrap.innerHTML = fams.map(function (f) {
        return '<button type="button" class="hydro-wall__chip' + (f === 'All' ? ' is-active' : '') + '" data-family="' + f + '">' + f + '</button>';
      }).join('');
    }
    chipsWrap.addEventListener('click', function (e) {
      var c = e.target.closest('[data-family]'); if (!c) return;
      activeFamily = c.dataset.family;
      chipsWrap.querySelectorAll('.hydro-wall__chip').forEach(function (x) { x.classList.toggle('is-active', x === c); });
      render();
    });
    if (search) search.addEventListener('input', function () { query = search.value; render(); });

    var url = root.dataset.flavorsUrl;
    var boot = function () { chips(); render(); };
    // Prefer the flavor metaobject data rendered inline; fall back to the bundled asset.
    var inline = document.querySelector('[data-hydro-flavors]');
    if (inline) {
      try { data = JSON.parse(inline.textContent); } catch (e) {}
      boot();
    } else if (url) {
      fetch(url).then(function (r) { return r.json(); }).then(function (d) { data = d; boot(); }).catch(boot);
    } else { boot(); }
  }
  function initAll() { document.querySelectorAll('[data-hydro-wall]').forEach(initWall); }
  if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
